import { SpotConfig, SpotPlaceConfig, SpotTicker, SpotUserConfig } from '../data/Spot'

export function createDefaultSpotPlaceConfig(): SpotPlaceConfig {
    return {
        priceEndStep: 1,
        pricePlace: 2,
        propertyHighPlace: 8,
        propertyPlace: 4,
        volumePlace: 4,
        delegatePricePlace: 4
    }
}

export function createDefaultSpotConfig(): SpotConfig {
    return {
        baseSymbolId: '',
        betaShow: false,
        businessLine: '',
        businessType: '',
        displayName: '-/-',
        feeRateUpRatio: 0,
        makerFeeRate: 0,
        oldExchangeId: '',
        oldSymbolCode: '',
        openCostUpRatio: 0,
        placeConfig: createDefaultSpotPlaceConfig(),
        pricedSymbol: '',
        pricedSymbolId: '',
        realCapitalRateRadio: 0,
        symbolCode: '',
        symbolId: '',
        takerFeeRate: 0,
        baseSymbol: '',
        symbolDisplayName: '',
        displayRule: 0, // 由于其他二进制位没有确定含义，暂时只需要最低位的默认值
        isETF: false, // 是否是etf
        symbolClassify: 0
    }
}

/**
 * 默认的用户配置
 * @return {{alertForLazyOp: boolean, alertForProfitControl: boolean}}
 */
export function createDefaultUserConfig(): SpotUserConfig {
    return {
        agreedTime: -1,
        alertForLazyOp: 0,
        alertForProfitControl: true,
        switchForLazy: false,
        directionForLazy: 1,
        checkForMakerPO: true, // 挂单是否使用"只做Maker"模式
        checkForTakerIOC: true, // 吃单是否使用"IOC"
        checkForTakerFOK: false, // 吃单是否使用"FOK"
        checkForOpenMode: 1, // 开仓数量模式 1-百分比 2-盘口
        openPercent: 100, // 开仓数量百分比模式具体百分比
        checkForCloseMode: 1, // 平仓数量模式 1-百分比 2-盘口
        closePercent: 100, // 平仓数量百分比模式具体百分比
        isReady: false
    }
}

export function createDefaultSpotTicker(): SpotTicker {
    return {
        downTime: 0,
        settlePrice: 0,
        baseVolume: '',
        change: '',
        high: '',
        low: '',
        price: '',
        pricedSymbol: '',
        symbolCode: '',
        toUsdt: '',
        baseSymbol: '',
        sortId: -1,
        ot: '',
        scd: '',
        ts: '',
        op: '',
        status: '2',
        labelId: 0,
        before24Open: '0',
        risefallstatue: 0
    }
}

// export function createDefaultSpotCurrentOCOEntrustInfo(): SpotCurrentOCOEntrustInfo {
//     return {
//         id: '',
//         version: '',
//         strategyId: 0,
//         symbolId: '', //币对
//         pairLeft: '', //左币
//         pairRight: '', //右币
//         createTime: '', //创建时间戳
//         marginModelStr: '1', //杠杆买入类型。1:普通 2:自动借款。3:自动还款
//         ocoTypeStr: '1', //oco类型 1-买入 2-卖出
//         limitPrice: 0, //限价
//         triggerPrice: 0, //触发价格
//         delegatePrice: 0, //价格
//         delegateCount: 0, //数量
//         status: '1', //策略状态 1:新建状态  2:待触发、3:触发中、4:下单中、 5:撤单中、 6:已撤单  7:执行失败.  8: 已执行
//         statusDesc: '', //策略状态
//         strategyReason: '' //策略终止原因
//     }
// }

// // 逐仓杠杆档位信息
// export function createDefaultIsolateLevelInfo() {
//     return []
// }

// // 全仓档位信息
// export function createDefaultCrossLevelInfo() {
//     return {
//         level: 0, //档位
//         validleverage: 0,
//         maxLoanValuation: 0,
//         maxLoanBase: 0,
//         marginRateInit: 0,
//         marginRateMaintain: 0
//     }
// }

// // 杠杆白名单
// export function createDefaultLanguageWhiteList() {
//     return {
//         openLanguageWhiteList: false, //没开启
//         languageWhiteList: []
//     }
// }
